// copy-paste from reach-router

type Params = {
  [name: string]: any;
};

const segmentize = (uri: string) =>
  uri
    // strip starting/ending slashes
    .replace(/(^\/+|\/+$)/g, '')
    .split('/');

const paramRe = /^:(.+)/;

const addQuery = (pathname: string, ...q: any[]) => {
  const query = q.filter(qa => qa && qa.length > 0);
  return pathname + (query && query.length > 0 ? `?${query.join('&')}` : '');
};

export const insertParams = (path: string, params: Params) => {
  const [pathBase, query = ''] = path.split('?');
  const segments = segmentize(pathBase);
  let constructedPath = `/${segments
    .map(segment => {
      const match = paramRe.exec(segment);
      return match ? params[match[1]] : segment;
    })
    .join('/')}`;
  const { location: { search = '' } = {} } = params;
  const searchSplit = search.split('?')[1] || '';
  constructedPath = addQuery(constructedPath, query, searchSplit);
  return constructedPath;
};
